var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPatternTwoCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 292,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D0202",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D0202",
    stopOpacity: 0.498,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)",
    fillRule: "evenodd",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(1 0 0 -1 0 292)",
    cx: 146,
    cy: 146,
    r: 146
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(0 1 1 0 292 -292)",
    cx: 438,
    cy: 146,
    r: 146
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternTwoCircles);
export default __webpack_public_path__ + "static/media/bg-pattern-two-circles.daeea6c523021cc2e039d1a4f729a9ca.svg";
export { ForwardRef as ReactComponent };